import { IonImg } from '@ionic/react';
import { useEffect, useRef, useState } from 'react';

import { mergeClassNames } from '@/utils/mergeClassNames';

import StepOne from '@/assets/circleAnimation/step-1.svg';
import StepTwo from '@/assets/circleAnimation/step-2.svg';
import StepThree from '@/assets/circleAnimation/step-3.svg';
import StepFour from '@/assets/circleAnimation/step-4.svg';
import StepFive from '@/assets/circleAnimation/step-5.svg';
import StepSix from '@/assets/circleAnimation/step-6.svg';
import StepSeven from '@/assets/circleAnimation/step-7.svg';

import styles from './CircleAnimation.module.css';

interface CircleAnimationProps {
  className?: string;
}

export const CircleAnimation = ({ className }: CircleAnimationProps) => {
  const [activeCircle, setActiveCircle] = useState(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const steps = [StepOne, StepTwo, StepThree, StepFour, StepFive, StepSix, StepSeven];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveCircle((prev) => {
        if (prev === steps.length - 1) {
          if (!timeoutRef.current) {
            timeoutRef.current = setTimeout(() => {
              setActiveCircle(0);
              timeoutRef.current = null;
            }, 650);
          }

          return prev;
        }

        return prev + 1;
      });
    }, 160);

    return () => {
      clearInterval(interval);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, []);

  return (
    <div className={mergeClassNames(styles.circles, className)}>
      {steps.map((step, index) => (
        <IonImg
          className={mergeClassNames(styles.step, index === activeCircle && styles.active)}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          src={step}
        />
      ))}
    </div>
  );
};
